import React from 'react';

import { Conf } from '~/presentation/pages';

export const MakeConfPage: React.FC = (): JSX.Element => {
  return <Conf />;
};
